import { createFileRoute } from '@tanstack/react-router';
import { AboutPage } from '~/components/pages/AboutPage';
import { aboutMeta } from '~/content/about';
import { pageHeadMeta } from '~/lib/seo';

export const Route = createFileRoute('/about')({
  head: () =>
    pageHeadMeta({
      title: aboutMeta.title,
      description: aboutMeta.description,
      path: '/about',
    }),
  component: AboutPage,
});
